import React from 'react'
import { css } from '@emotion/css'
import { WithTooltip } from '../../../design-system'
import { FormattedMessage } from 'react-intl'
import {
  Toggle,
  OptimisticToggleManager
} from '../../../legacy-design-system/toggle'
import { ToggleSensitiveDataPolicyMutation } from '../toggle-sensitive-data-policy-mutation'
import { sendDefaultEvent } from '../../analytics'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export function ToggleCell({
  organizationID,

  rowData: { id, enabled, disabled, required },
  refetch
}: {
  readonly organizationID: string
  readonly rowData: {
    readonly id: string
    readonly enabled: boolean
    readonly disabled: boolean
    readonly required: boolean
  }
  readonly refetch: () => Promise<any>
}) {
  return required === true ? (
    <WithTooltip
      containerClassName={css`
        justify-content: center;
      `}
      children={() => (
        <Toggle disabled={required} checked={enabled} onChange={() => false} />
      )}
      renderTooltipContent={() => (
        <FormattedMessage id="detail_sensitiveData_criticalDataTypesCannotBeDisabled" />
      )}
    />
  ) : (
    <ToggleSensitiveDataPolicyMutation>
      {(toggle) => {
        return (
          <ContrastFormattedMessage
            id={
              enabled
                ? 'detail_sensitiveData_successfullyDisabledPolicy'
                : 'detail_sensitiveData_successfullyEnabledPolicy'
            }
            children={(successMessage) => (
              <ContrastFormattedMessage
                id={
                  enabled
                    ? 'detail_sensitiveData_errorDisablingPolicy'
                    : 'detail_sensitiveData_errorEnablingPolicy'
                }
                children={(errorMessage) => (
                  <OptimisticToggleManager checked={enabled}>
                    {({ checked, isUpdating, setIsUpdating }) => {
                      return (
                        <Toggle
                          disabled={required || isUpdating || disabled}
                          checked={checked}
                          onChange={async () => {
                            setIsUpdating(true)
                            sendDefaultEvent(
                              enabled
                                ? 'sensitive.data.policy.disable'
                                : 'sensitive.data.policy.enable'
                            )
                            await toggle(
                              {
                                organizationID,
                                policyID: id,
                                enabled: !enabled
                              },
                              successMessage,
                              errorMessage
                            )
                            await refetch()
                          }}
                        />
                      )
                    }}
                  </OptimisticToggleManager>
                )}
              />
            )}
          />
        )
      }}
    </ToggleSensitiveDataPolicyMutation>
  )
}
